
// src/pages/Dashboard/vendor-balance/index.jsx
import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styles from './index.module.css';
import VendorBalanceChart from './components/VendorBalanceChart';
import VendorBalanceTable from './components/VendorBalanceTable';
import VendorTopOutstanding from './components/VendorTopOutstanding';

const VendorBalance = () => {
  const [activeSection, setActiveSection] = useState('balance');
  const { sidebarOpen } = useOutletContext();

  return (
    <div className={`${styles.container} ${sidebarOpen ? styles.sidebarOpen : styles.sidebarClosed}`}>
      <div className={styles.content}>
        <div className={styles.sectionTabs}>
          <button
            className={`${styles.tabButton} ${activeSection === 'balance' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('balance')}
          >
            Vendor Balance
          </button>
          <button
            className={`${styles.tabButton} ${activeSection === 'topOutstanding' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('topOutstanding')}
          >
            Top Outstanding
          </button>
        </div>

        {activeSection === 'balance' && (
          <div className={styles.sectionContent}>
            <VendorBalanceChart />
            <VendorBalanceTable />
          </div>
        )}

        {activeSection === 'topOutstanding' && (
          <div className={styles.sectionContent}>
            <VendorTopOutstanding />
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorBalance;